var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M22.412-.001c11.828 0 21.413 9.66 21.413 21.571 0 5.478-2.03 10.479-5.37 14.283l15.476 15.6a2.673 2.673 0 0 1-.01 3.77 2.653 2.653 0 0 1-3.759-.01L34.47 39.399a21.2 21.2 0 0 1-12.057 3.743C10.584 43.14 1 33.48 1 21.57S10.584-.002 22.412-.002m0 4.268c-9.474 0-17.158 7.745-17.158 17.303s7.684 17.304 17.158 17.304 17.159-7.745 17.16-17.304c0-9.558-7.686-17.303-17.16-17.303"
  })));
};
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "54941507a219819b14669af4154d5366.svg";